export default function staffResult() {

    return {
        scope: true,
        replace: true,
        restrict: 'EA',
        template:`
        <li>
            <div class="staff-card">
                <img class="staff-card-image" ng-if="result.imageUrl" ng-src="{{ ::result.imageUrl }}" alt="{{:: result.name }}" />
                <div class="staff-card-icon" ng-if="!result.imageUrl">
                    <i class="fal fa-user"></i>
                </div>

                <div class="d-flex flex-column contact">
                    <h5 class="staff-card-title" ng-if="result.url !== '#'">
                        <a ng-href="{{ ::result.url }}">
                            {{ ::result.name }}
                        </a>
                    </h5>

                    <h5 class="staff-card-title" 
                        ng-if="result.url === '#'" 
                        ng-bind="::result.name"></h5>                

                    <small class="mb-3" 
                        ng-if="result.staffDetail.position" 
                        ng-repeat="value in result.staffDetail.position" 
                        ng-class="{ 'last' : $last }">
                            {{ ::value }}{{ $last ? '' : ';' }}
                    </small>
                
                    <div class="mt-auto" ng-if="result.staffDetail.email || result.staffDefault.telephone">
                        <p class="mb-0" ng-if="result.staffDetail.email" >
                            <a href="mailto:{{ result.staffDetail.email }}" ng-bind="::result.staffDetail.email | lowercase"></a>
                        </p>
                        <p class="mb-0" ng-if="result.staffDetail.telephone">
                            <a href="tel:{{ result.staffDetail.telephone }}" ng-bind="::result.staffDetail.telephone"></a>
                        </p>
                    </div>
                </div>
            </div>
        </li>`
    };
}